interface IUseSessionStorage<T> {
  setStoreSession: (nameStore: string, value: T) => boolean
  removeStoreSession: (nameStore: string) => void
  getStoreSession: (nameStore: string) => T
}

export const useSessionStorage = <T,>(): IUseSessionStorage<T> => {
  const isBrowser: boolean = ((): boolean => typeof window !== 'undefined')()

  const setStoreSession = (nameStore: string, value: T): boolean => {
    if (isBrowser) {
      sessionStorage.setItem(nameStore, JSON.stringify(value))
      return true
    }
    return false
  }

  const removeStoreSession = (nameStore: string): void => {
    if (isBrowser) {
      sessionStorage.removeItem(nameStore)
    }
  }

  const getStoreSession = (nameStore: string): T => {
    if (isBrowser) {
      const value = sessionStorage.getItem(nameStore)
      return value ? JSON.parse(value) : null
    }
    return null
  }

  return { setStoreSession, removeStoreSession, getStoreSession }
}
